module.exports = __webpack_public_path__ + "7ead35e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/icons/yourCarIcon.svg
// module id = 3295
// module chunks = 32